import { createFileRoute } from "@tanstack/react-router";

import { VehicleStickerForm } from "~/components/VehicleStickerForm";
import { useI18n } from "~/lib/i18n";
import { ui } from "~/lib/ui";

export const Route = createFileRoute("/v/")({
  component: VerifyByCode,
});

function VerifyByCode() {
  const { t } = useI18n();

  return (
    <div className="mx-auto max-w-xl space-y-6">
      <div>
        <h1 className={ui.h1}>{t("verifyVehicle")}</h1>
        <p className={ui.lead}>{t("verifyIntro")}</p>
      </div>
      <VehicleStickerForm />
    </div>
  );
}
